import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Icon, Row, Switch} from "antd";
import * as translations from "../../../constants/translations";
import * as formTypes from "../../../constants/formtypes";
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;


class InverterNew extends Component {

    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                location: PropTypes.string.isRequired,
                logger: PropTypes.string.isRequired,
            }).isRequired
        }).isRequired
    };

    state = {
        data: {
            "type": "",
            "panels": 0,
            "wp": 300,
            "active": true,
            "address": "1",
            "yield_factor": 0.88
        },
        saving: false
    };

    formFieldTypes = {
        "type": formTypes.TEXT,
        "panels": formTypes.NUMBER,
        "wp": formTypes.NUMBER,
        "active": formTypes.BOOLEAN,
        "address": formTypes.TEXT,
        "yield_factor": formTypes.FLOAT
    };

    save = async () => {
        if(this.state.data.type && this.state.data.panels
           && this.state.data.wp) {
            this.setState({saving: true});

            const request = await fetch(`${benchmarkApi}inverters` ,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify({...this.state.data, ...{location: this.props.match.params.location, logger: this.props.match.params.logger}})
            });
            const response = await request.json();
            console.log('save', response);

            const req2 = await fetch(`${benchmarkApi}export/inverters/${response[""]}`,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify(this.state.data)
            });

            console.log("req2", await req2.text());

            this.setState({saving: false, data: 'reloading'});
            window.location = "/locaties/"+this.props.match.params.location;
        }
    }

    renderInput = (key) => {
        switch(this.formFieldTypes[key]){
            case formTypes.TEXT:
                return (
                    <input type="text" value={this.state.data[key]} onChange={(event) => {
                        const data = {...this.state.data};
                        data[key] = event.target.value;
                        this.setState({data: data})
                    }} />
                )
            case formTypes.NUMBER:
                return (
                    <input type="number" min="0" step="1" value={this.state.data[key]} onChange={(event) => {
                        const data = {...this.state.data};
                        data[key] = event.target.value;
                        this.setState({data: data})
                    }} />
                )
            case formTypes.FLOAT:
                return (
                    <input type="number" min="0" value={this.state.data[key]} onChange={(event) => {
                        const data = {...this.state.data};
                        data[key] = event.target.value;
                        this.setState({data: data})
                    }} />
                )
            case formTypes.BOOLEAN:
                return (
                    <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="close" />} checked={this.state.data[key]} value={this.state.data[key]} onChange={(val) => {
                        const data = {...this.state.data};
                        data[key] = val;
                        this.setState({data: data})
                    }} />
                )
            default:
                return (
                    <input type="text" value={this.state.data[key]} onChange={(event) => {
                        const data = {...this.state.data};
                        data[key] = event.target.value;
                        this.setState({data: data})
                    }} />
                )
        }
    }

    renderCol = (key, val) => {
        return <Row gutter={{xs: 0, md: 24}} className="dataview-row" key={key}>
            <Col xs={24} md={8} className="dataview-label">{translations.inverter[key] ? translations.inverter[key] : key}</Col>
            <Col xs={24} md={15} className="dataview-value">
                {
                    !this.formFieldTypes[key] || this.formFieldTypes[key] === formTypes.NONE ?
                         val : this.renderInput(key)
                }
            </Col>
        </Row>;
    }

    render() {
        const {data} = this.state;
        return (
            <div>
                <div>
                    <h1>Nieuwe omvormer toevoegen</h1>
                    {Object.keys(data).filter(key => key !== "name").map((key) => this.renderCol(key, data[key]))}
                    <div>
                        <Button type={'primary'} onClick={this.save} loading={this.state.saving}>Opslaan</Button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {return {}};

export default connect(mapStateToProps)(InverterNew);



// WEBPACK FOOTER //
// ./src/components/baseinfo/inverters/new.js